import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from 'uuid';
import { APPEND_SONGS } from "@/redux/features/music/musicSlice";
import axios from "axios";
import ani1 from "../../assets/createani1.gif"
import ani2 from "../../assets/createani2.gif"
import ani3 from "../../assets/createani3.gif"
import { SET_CREDITS, SET_SHOW_LOGIN } from "@/redux/features/auth/authSlice";
import { ADD_CREATING_SONG, REMOVE_CREATING_SONG, SET_CREATEHOMEDESC, STOP_LIVESONG, UPDATE_CREATING_SONG } from "@/redux/features/music/createSlice";
import { logEvent } from "firebase/analytics";
import { analytics } from "@/firebase";
import { Loader2 } from "lucide-react";
import { trackMetaCustomEvent } from "@/utils/metaPixel";
import { trackLinkedInEvent } from "@/utils/linkedinTag";
import { trackRedditCustomEvent } from "@/utils/redditPixel";
import { Dices } from "lucide-react";

const CreateSongHomeComp = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    // creating ref to use in change status function
    const creatinRef = useRef({})
    const { user } = useSelector(state => state.auth)
    const { createHomeDesc, creatingSongs } = useSelector(state => state.create)
    const pollIntervalsRef = useRef({});
    const [isLoading, setIsLoading] = useState(false)

    // Add this array of prompts
    const randomPrompts = [
        "A melancholic piano ballad about lost love in a rainy city",
        "Upbeat electronic dance track with tropical vibes and synth waves",
        "Epic orchestral arrangement inspired by ancient warrior battles",
        "Soulful R&B groove with smooth vocals and jazzy undertones",
        "Futuristic cyberpunk theme with heavy bass and glitch effects",
        "Acoustic folk song about a journey through the mountains",
        "Psychedelic rock anthem with distorted guitars and reverb",
        "Cinematic trailer music with choir vocals and pounding drums",
        "Chill lo-fi hip hop beat perfect for studying or relaxing",
        "Reggae-inspired summer jam with brass section and off-beat rhythms",
        "Haunting ambient soundscape evoking forgotten civilizations",
        "Jazz fusion piece blending traditional Indian ragas with modern synthpop",
        "High-energy K-pop anthem with addictive hooks and rap breakdown",
        "Post-apocalyptic industrial rock with distorted vocals and machine rhythms",
        "Romantic bollywood-style orchestration with soaring strings and tabla beats",
        "Minimalist techno track building tension through subtle texture changes",
        "Christmas carol reimagined as darkwave synth ballad with choral elements",
        "Progressive metal odyssey with complex time signatures and virtuoso solos",
        "Afrobeat-inspired celebration rhythm with polyrhythmic percussion section",
        "Dreamy shoegaze composition with wall-of-sound guitars and whispered vocals",
        "Neo-soul groove featuring vintage Rhodes piano and smooth bassline",
        "Psytrance journey with hypnotic arpeggios and evolving atmospheric layers",
        "Bluegrass folk tale with banjo, fiddle, and three-part harmony vocals",
        "Cinematic space opera theme using theremin and orchestral hits",
        "Lofi hiphop beat with vinyl crackle and nostalgic anime sample chops",
        "Reggaeton dembow rhythm paired with Middle Eastern flute melodies",
        "Hindi Bollywood dance number with dholak rhythms and romantic Urdu poetry",
        "Punjabi bhangra beat fused with trap bass and tumbi instrumentals in punjabi language",
        "Malayalam folk fusion featuring chenda drums and electronic synth patterns in malayalam language",
        "French chanson-style ballad with accordion melodies and poetic lyrics in french language",
        "Russian hardbass track with heavy kicks and traditional balalaika samples in russian language",
        "K-pop meets Hindi lyrics: EDM drop with classical sitar interludes in hindi language",
        "Spanish flamenco guitar blended with Malayalam folk vocal harmonies in spanish language",
        "Japanese city pop revival with French lyrics and funky basslines in japanese language",
        "Arabic maqam scales meets Punjabi dhol rhythms in a dancefloor filler in arabic language",
        "Tamil filmi-style orchestration with Russian choir vocal layers in tamil language",
        "Portuguese fado ballad featuring melancholic Hindi lyrics translation in portuguese language",
        "Korean trot music influenced by Malayalam folk song structures in korean language",
        "German techno track with sampled Russian folk chants and hardstyle kicks in german language",
        "Italian opera aria reinterpreted with Hindi lyrics and tabla accompaniment in italian language"
    ];

    const handleLyricsChange = (e) => {
        dispatch(SET_CREATEHOMEDESC(e.target.value))
    }
    // Create request
    const handleCreate = async () => {

        if ((user?.is_guest || user?.plan === 0) && creatingSongs?.length >= 1) {
            return toast.error("One song generation at a time, Upgrade plan to create more", { id: "create", duration: 5000 })
        }
        if (user?.plan === 1 && creatingSongs?.length >= 2) {
            return toast.error("You can only create 2 songs simultaneously, Upgrade plan to create more", { id: "create", duration: 5000 })
        }
        if (user?.plan === 2 && creatingSongs?.length >= 3) {
            return toast.error("You can only create 3 songs simultaneously, Upgrade plan to create more", { id: "create", duration: 5000 })
        }
        if (user?.plan === 3 && creatingSongs?.length >= 5) {
            return toast.error("Maximum 5 simultaneously song generations are allowed", { id: "create", duration: 5000 })
        }
        // validation
        if (!createHomeDesc || createHomeDesc.length === 0 || createHomeDesc === ",") {
            return toast.error("Please enter song description", { id: "create" })
        }
        const creationId = uuidv4();
        try {
            setIsLoading(true)
            toast.loading("Initializing", { id: "credits" })
            const token = localStorage.getItem('token') || localStorage.getItem("guestToken")
            const { data } = await axios.get("/balance", { headers: { Authorization: `Bearer ${token}` } })
            dispatch(SET_CREDITS(data?.amount))
            if (data?.amount < 100) {
                setIsLoading(false);
                if (user?.is_guest) {
                    toast.error("Not enough credits, Login to create song", { id: "credits" })
                    dispatch(SET_SHOW_LOGIN(true));
                    return
                }
                return toast.error("Not enough credits", { id: "credits" })
            } else {
                toast.dismiss("credits")
            }
            toast.loading("Sending Request", { id: creationId })
            const formData = {
                prompt: createHomeDesc,
                publish: user?.is_guest ? false : true,
            }
            const response = await axios.post("https://engine.soundofmeme.com/create",
                formData,
                { headers: { Authorization: `Bearer ${token}` } })

            const songIds = response.data.songs
            const songIdsArr = songIds?.split(',')
            const songsArray = songIdsArr.map(id => ({ song_id: parseInt(id) }))
            creatinRef.current[creationId] = true
            dispatch(ADD_CREATING_SONG({ creationId: creationId, feat: "create", songs: songsArray }))
            changeStatus(creationId)
            startPollingForSongCompletion(songIds, creationId)
            dispatch(SET_CREDITS(data?.amount - 100)) // after creation credits are deducted and shown in the credits span
            setIsLoading(false)
            dispatch(SET_CREATEHOMEDESC(''))
            navigate("/creations")
        } catch (error) {
            toast.dismiss("credits")
            setIsLoading(false)
            handleError(error, creationId)
        }
    }

    // Polling method for song completion
    const startPollingForSongCompletion = (songIds, creationId) => {
        const interval = setInterval(async () => {
            try {
                const token = localStorage.getItem('token') || localStorage.getItem("guestToken")
                const { data } = await axios.get(`/songs/?song_ids=${songIds}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (data === null) {
                    toast.error("Unexpected Error, Received null response")
                    clearInterval(interval)
                    delete pollIntervalsRef.current[songIds]
                    dispatch(REMOVE_CREATING_SONG({ creationId }));
                    delete creatinRef.current[creationId];
                } else if (data.status === 'completed') {
                    clearInterval(interval);
                    delete pollIntervalsRef.current[songIds];
                    dispatch(REMOVE_CREATING_SONG({ creationId }));
                    dispatch(APPEND_SONGS(data.songs));
                    dispatch(SET_CREDITS(user?.credits - 100))
                    // dispatch(STOP_LIVESONG())
                    toast.success(`All done! Your song is ready to play.`, { id: creationId });
                    delete creatinRef.current[creationId];
                    logEvent(analytics, 'song_creation', {
                        method: "create",
                        success: true,
                        songId: songIds,
                    });
                    trackMetaCustomEvent('song_creation', {
                        method: "create",
                        success: true,
                        songId: songIds,
                    })
                    trackLinkedInEvent('song_creation', {
                        event: 'song_creation',
                        success: true,
                        songId: songIds,
                        method: "create",
                    });
                    trackRedditCustomEvent('song_creation', {
                        event: 'song_creation',
                        success: true,
                        songId: songIds,
                        method: "create",
                    });
                } else {
                    dispatch(UPDATE_CREATING_SONG({ creationId: creationId, songs: data.songs }))
                }
            } catch (error) {
                dispatch(STOP_LIVESONG())
                clearInterval(interval)
                delete pollIntervalsRef.current[songIds];
                handleError(error, creationId);
                // Only log failure if there are no next IDs
                if (!error?.response?.data?.next_ids) {
                    logEvent(analytics, 'song_creation', {
                        success: false,
                        songId: songIds,
                        method: "create",
                    });
                    trackMetaCustomEvent('song_creation', {
                        success: false,
                        songId: songIds,
                        method: "create",
                    })
                    trackLinkedInEvent('song_creation', {
                        event: 'song_creation',
                        success: false,
                        songId: songIds,
                        method: "create",
                    });
                    trackRedditCustomEvent('song_creation', {
                        event: 'song_creation',
                        success: false,
                        songId: songIds,
                        method: "create",
                    });
                }
            }
        }, 10000);
        // Store interval ID for cleanup
        pollIntervalsRef.current[songIds] = interval;
    };

    // Handle errors
    const handleError = (error, creationId) => {
        console.error(error);
        const nextSongIds = error?.response?.data?.next_ids;
        if (nextSongIds) {
            const songIdsArr = nextSongIds.split(',');
            const songsArray = songIdsArr.map(id => ({ song_id: parseInt(id) }));
            dispatch(UPDATE_CREATING_SONG({
                creationId: creationId,
                songs: songsArray
            }));
            startPollingForSongCompletion(nextSongIds, creationId);
            creatinRef.current[creationId] = true;
        } else {
            dispatch(REMOVE_CREATING_SONG({ creationId }));
            delete creatinRef.current[creationId];
            toast.error(
                error?.response?.data?.detail ||
                error.message ||
                "Oops! Something went wrong. Please try again.",
                { id: creationId }
            );
        }
    };

    // Change status function
    const changeStatus = useCallback((creationId) => {
        toast("Crafting your tune, hang tight!", { id: creationId })
        dispatch(UPDATE_CREATING_SONG({ creationId: creationId, ani: ani1, text: "Analyzing your description..." }))
        setTimeout(() => {
            if (!creatinRef.current[creationId]) return toast.dismiss(creationId);
            dispatch(UPDATE_CREATING_SONG({ creationId: creationId, ani: ani2, text: "Adding the rhythms..." }))
        }, 15000);
        setTimeout(() => {
            if (!creatinRef.current[creationId]) return toast.dismiss(creationId);
            dispatch(UPDATE_CREATING_SONG({ creationId: creationId, ani: ani3, text: "Composing your melody..." }))
        }, 30000);
    }, [dispatch])

    // Add this function
    const handleRandomPrompt = () => {
        // Create a copy of the array and shuffle it
        const shuffledPrompts = [...randomPrompts].sort(() => Math.random() - 0.5);
        const randomIndex = Math.floor(Math.random() * shuffledPrompts.length);
        dispatch(SET_CREATEHOMEDESC(shuffledPrompts[randomIndex]));
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (createHomeDesc.trim() !== '') {
                event.preventDefault();
                event.returnValue = ''; // Required for modern browsers
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [createHomeDesc]);

    return (
        <div className={` w-full xl:w-1/2 flex-shrink-0 p-4 pt-0 xl:pt-4 pb-0`}>
            <Card className="bg-transparent border-none pb-2 h-full flex flex-col">
                <CardHeader className="p-0 pb-2" >
                    <CardTitle className="text-slate-200 sm:text-2xl font-bold font-poppins text-xl flex items-center justify-between gap-2" >
                        <span>Create Song</span>
                        <p className="text-slate-300 font-medium font-poppins text-sm mt-3 flex items-center gap-2" > <span>Credits: {user?.credits}</span>  |  <span>Cost: 100</span></p>
                    </CardTitle>
                </CardHeader>
                <CardContent className=" flex-grow flex flex-col justify-end gap-4 text-slate-200 dark:text-slate-800 p-0 sm:pt-2 pt-0">
                    <div className="relative flex-grow">
                        <textarea id="description" type="text" placeholder="Start with a feeling, a story, or just a single sentence... What do you want your song to be about? Let the music begin!" value={createHomeDesc} onChange={handleLyricsChange} className=" h-full w-full bg-slate-900/60 border  border-1 border-slate-400/30 rounded-lg min-h-28 p-2 placeholder:text-sm placeholder:text-slate-600 placeholder:font-medium focus:outline-none focus:ring-1 ring-green-400 shadow-md shadow-green-400/10" >
                        </textarea>
                        <button type="button" onClick={handleRandomPrompt} className="absolute right-2 md:bottom-2 bottom-2 p-1.5 transition-colors group" aria-label="Get random prompt" >
                            <Dices className="w-5 h-5 text-slate-300 group-hover:text-green-400 transition-colors" />
                        </button>
                    </div>
                    <div className="flex justify-end w-full">
                        <button disabled={isLoading} onClick={handleCreate} className='flex items-center justify-center  w-full sm:gap-2 disabled:opacity-50 border border-1  font-semibold font-poppins text-sm py-2 px-2 rounded-sm shadow-md shadow-green-400/10 hover:shadow-green-400/20 opacity-90 hover:opacity-100 border-green-400/40 bg-gradient-to-r from-green-400 to-teal-400 text-black transition-all duration-200' >
                            {isLoading ? (
                                <div className="flex items-center gap-2">
                                    <span>Creating...</span>
                                    <Loader2 className="w-4 h-4 animate-spin" />
                                </div>
                            ) : (
                                <span>Create Song</span>
                            )}
                        </button>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default CreateSongHomeComp;